module.exports = __webpack_public_path__ + "img/9.3.TP.7b8508a5.png";